import { render, staticRenderFns } from "./MinimizeIcon.vue?vue&type=template&id=50f91c04"
import script from "./MinimizeIcon.vue?vue&type=script&lang=ts"
export * from "./MinimizeIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports